import React, { useEffect, useRef } from "react";
import styles from "./NextButton.module.css";

const NextButton = ( { handleClickNext } ) =>
{
    const buttonRef = useRef();


    useEffect( () =>
    {
        buttonRef.current.focus();
    }, [])
    return(
        <>
            <button className={styles.root} ref={buttonRef} onClick={handleClickNext}>Next</button>
        </>
    )
}

export default NextButton;
